import React, {Component} from "react";
import {browserHistory, IndexRoute, Route, Router} from "react-router";
import Overview from "./components/Overview.jsx";
import Main from "./components/Main.jsx";
import ObjectMap from "./components/ObjectMap.jsx";
import Maps from "./components/Maps.jsx";
import ObjectInfo from "./components/ObjectInfo.jsx";

class App extends Component {

    render() {
        return (
            <Router history={browserHistory}>
                <Route path="/:widget" component={Main}>
                    <IndexRoute component={Overview}/>
                    <Route path="map" component={Maps}>
                        <Route name="map" path=":id" component={ObjectMap}/>
                    </Route>
                    <Route path="map/:id/object/:number" component={ObjectInfo}/>
                </Route>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js